import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

type PhoneCheckIllustrationProps = {
	/** Frame and check colour: white on the coloured drawer, black on a white modal. */
	color?: "white" | "black";
	scale?: number;
};

/** A phone outline with a check mark — the non-RFID "finish in the app" motif (prototype). */
export const PhoneCheckIllustration = ({ color = "white", scale = 1 }: PhoneCheckIllustrationProps) => (
	<PhoneFrame
		sx={{
			width: 180 * scale,
			height: 300 * scale,
			borderRadius: `${32 * scale}px`,
			borderWidth: 6 * scale,
			color: color,
			borderColor: color,
		}}
	>
		<TaskAltIcon sx={{ fontSize: 120 * scale }} />
	</PhoneFrame>
);

const PhoneFrame = styled(Box)(() => ({
	borderStyle: "solid",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	flex: "none",
}));
